import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import PropTypes from 'prop-types'
import { createStructuredSelector } from 'reselect'
import { withRouter } from 'react-router-dom'

import {
  makeSelectHasMtiRole,
  makeSelectMtiPermission,
} from '../../../containers/App/selectors'
import {
  fetchAndUpsertStore,
  notifyModal,
  storeDetailsAction,
} from '../../../containers/App/actions'
import { loadStores } from '../../../containers/StoresPage/actions'
import { makeSelectLoading } from '../../../containers/HomePage/StoreManagerOrStaff/selectors'
import { selectStoreById } from '../../Breadcrumbs/selectors'
import { selectStoreHasMissingSecuredProducts } from '../../../containers/ExceptionsList/SecuredProducts/selectors'
import { selectStoreID } from './selectors'
import { selectStoreIDFromURL } from '../../../utils/utils'
import { StoreManagerOrStaff } from '../../../containers/HomePage/StoreManagerOrStaff'
import DrawerLinksScreen from './index.screen'
import { closeDrawer } from '../Button'

class StoreManagerDrawer extends React.PureComponent {
  componentDidMount() {
    this.props.loadStores()
  }

  onItem = (event, item) => {
    closeDrawer()
    StoreManagerOrStaff.onItem(event, item, this.props)
  }

  render() {
    const { store, history } = this.props
    const items = StoreManagerOrStaff.getItemsData(store, this.props)
    if (!store) {
      return null
    }

    return (
      <DrawerLinksScreen
        quickActionsItems={items}
        onItem={this.onItem}
        history={history}
      />
    )
  }
}

// This function is annoyingly referenced in a bunch of other corporate user stuff and should only
// try to grab the id from the url and the 'editStores' data for those locations.
export function getStoreId(state) {
  let sId = selectStoreIDFromURL()

  if (!sId) {
    const reduxStore = state.get('editStores')
    sId = reduxStore && (reduxStore.get('store') || {}).id
  }

  return sId
}

// Because the exported getStoreId is being used by a bunch of corporate user stuff,
// this function is a local wrapper to add a fallback for store users.
function _getStoreId(state) {
  let id = getStoreId(state)
  if (!id) { id = selectStoreID(state) }
  return id
}

const mapStateToProps = createStructuredSelector({
  hasStoreManagerRole: (state, ownProps) =>
    makeSelectHasMtiRole('Store Manager', _getStoreId(state))(state, ownProps),
  hasViewKeysPermission: (state, ownProps) =>
    makeSelectMtiPermission(
      'Physical Key: Index (list) Records',
      _getStoreId(state)
    )(state, ownProps), // deprecated name 'viewKeys'
  hasViewStoreReportsPermission: (state, ownProps) =>
    makeSelectMtiPermission(
      'Saved Report: Index (list) Records',
      _getStoreId(state)
    )(state, ownProps), // deprecated name 'viewStoreReports'
  hasViewUsersPermission: (state, ownProps) =>
    makeSelectMtiPermission('User: Index (list) Records', _getStoreId(state))(
      state,
      ownProps
    ), // deprecated name 'viewUsers'
  hasViewSchedulesPermission: (state, ownProps) =>
    makeSelectMtiPermission(
      'Schedule: Index (list) Records',
      _getStoreId(state)
    )(state, ownProps), // deprecated name 'viewUsers'
  store: (state, ownProps) =>
    selectStoreById({
      sId: _getStoreId(state),
    })(state, ownProps),
  loading: makeSelectLoading(),
  hasMissingSecuredProducts: (state) =>
    selectStoreHasMissingSecuredProducts(state, _getStoreId(state)),
})

const mapDispatchToProps = {
  notifyModal,
  storeDetailsAction,
  fetchAndUpsertStore,
  loadStores,
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

StoreManagerDrawer.propTypes = {
  history: PropTypes.object.isRequired,
  notifyModal: PropTypes.func,
  storeDetailsAction: PropTypes.func,
  hasViewKeysPermission: PropTypes.bool,
  hasViewStoreReportsPermission: PropTypes.bool,
  hasViewUsersPermission: PropTypes.bool,
  hasViewSchedulesPermission: PropTypes.bool,
  loadStores: PropTypes.func.isRequired,
  store: PropTypes.object,
}

export default compose(withConnect)(withRouter(StoreManagerDrawer))
